import { Teacher } from '../generated/Teacher';
import { TeacherBbs } from '../generated/TeacherBbs';
import { UserAuth } from '../generated/UserAuth';

export class BBSDTO {
  bbs!: TeacherBbs;
  user!: UserAuth;
  teacher!: Teacher;
}
